import $ from 'jquery';

class ReadMore {
	constructor() {
		this.button = $( '[data-read-more]' );
		this.buttonParent = this.button.parent();
		this.text = $( '[data-read-more-text]' );
		this.textMaxHeight = this.text.data( 'read-more-text' );

		this.events();
		this.documentReady();
	}

	events() {
		this.buttonParent.on( 'click',
			'[data-read-more]',
			() => {
				this.text.hasClass( 'hide-text' ) ? this.showText() : this.hideText(); // eslint-disable-line no-unused-expressions
			}
		);
	}

	documentReady() {
		if ( 0 === $.trim( this.text.html() ).length ) {
			this.button.hide();
			return;
		}

		if ( this.textMaxHeight >= this.text.outerHeight() ) {
			this.button.hide();
			return;
		}

		this.text.css( 'max-height', this.textMaxHeight );
		this.text.addClass( 'hide-text' );
	}

	showText() {
		this.text.css( 'max-height', 'none' );
		this.text.removeClass( 'hide-text' );
		this.button.html( mainScriptTranslations.showLess ); // eslint-disable-line no-undef
	}

	hideText() {
		this.text.css( 'max-height', this.textMaxHeight );
		this.text.addClass( 'hide-text' );
		this.button.html( mainScriptTranslations.showMore ); // eslint-disable-line no-undef
	}
}

export default ReadMore;
